var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.3042 8L32 8L32 9L-3.80395e-07 9L-3.36684e-07 8L4.69576 8C6.31349 8 7.86267 7.34675 8.99195 6.1884L13.8519 1.20338C15.0293 -0.00435564 16.9707 -0.00435746 18.1481 1.20337L23.008 6.1884C24.1373 7.34675 25.6865 8 27.3042 8Z","fill":"#FFF0BB"}));
}

Arrow.defaultProps = {"width":"32","height":"9","viewBox":"0 0 32 9","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
